import { render } from "./LiveTest.vue?vue&type=template&id=2bbe7f70"
import script from "./LiveTest.vue?vue&type=script&lang=js"
export * from "./LiveTest.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dashcam_front/dashcam_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__